<template>
  <div class="cs">
    <div class="content__loading" v-if="showloading"  >
      <div>
        <img src="../assets/loading.svg">
        <div>加载中</div>
      </div>
    </div>
    <div class="scrollView"  @scroll="elementScroll($event)" v-else>

      <div class="playerTemp" :style="{minHeight:playerheight + 'px'}"  >


        <div class="tv-player-placeholder" v-if="!playstate" @click="playstate=1" :style="{height:playerheight+'px'}">
          <img class="tv-player-placeholder-poster" :src="chengshi_news.thumb+'?x-oss-process=image/resize,m_lfit,h_500,w_900'">
          <div class="tv-player-placeholder-icon">
            <img src="../assets/play_fill.png">
          </div>

        </div>
        <div v-else>

          <video webkit-playsinline="true"
                 playsinline="true"
                 x-webkit-airplay="" class="chengshi_video" style="{minHeight:playerheight + 'px'}" v-if="chengshi_news && chengshi_news.play_info" :src="chengshi_news.play_info.path" :poster="chengshi_news.play_info.path+'?x-oss-process=video/snapshot,t_2000,f_jpg,m_fast'" controls autoplay></video>
        </div>
      </div>




      <div class="view"  @click="showTimeselect = true">
        <div class="view_sd1" >
          <div class="left-date">
            <div>{{currentDate.y}}</div>
            <div>{{currentDate.m}}月</div>
          </div>
          <div class="right-date">
            <div class="right-date-item" v-for="item in daylist" @click.stop="dayClick(item)">
              <div class="right-date-item-t" :class="{'active':item.d ==currentDate.d}">{{item.d}}</div>
            </div>


          </div>
        </div>
        <div class="view_sd2"></div>
        <div class="view_sd3"></div>
        <div class="view_more">查看更多>></div>
      </div>

      <div class="video-more-warp">
        <div class="left-img-list">
          <div class="left-img-list-item" v-for="(item,index) in chengshi_list" @click.stop="openconstent(item)">
            <div class="news-list-item-row">
              <img v-if="item.thumb"  v-lazy="item.thumb+'?x-oss-process=image/resize,m_lfit,h_360,w_380'" :style="{width:w+'px'}" class="news-list-item-img news-list-item-img-left" >
              <div class="news-list-item-row-left">
                <div class="news-list-item-title text-overflow">{{item.movie_name}}</div>
                <!--                            <div class="item-desc">{{item.content}}</div>-->
                <div class="news-list-item-date" @click.stop>


                  <span>{{item.publish_time}}</span>


                </div>
              </div>


            </div>

          </div>
        </div>


      </div>

    </div>

    <van-calendar v-model="showTimeselect" @confirm="onConfirm" :max-date="maxDate" :min-date="minDate"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import config from '../config'
import utils from '../utils'
import { Toast } from 'vant';
import request from "../utils/request";
export default {
  name: 'Home',
  data(){
    return {

      maxDate:new Date(Date.now()),
      minDate: new Date(2018, 11, 10),
      showTimeselect:false,
      showloading:true,
      screenHeight: document.body.clientHeight,
      hide: false,
      playstate:1,
      height: (document.body.clientWidth-30)/(16/9),
      w:(document.body.clientWidth-30)/3,

      html:"",
      timer:false,
      page:1,
      date_timestamp:"",
      chengshi_news:{
        play_info:{
          cover_url:"",
          path:""
        }
      },
      islive:false,
      playerheight:document.body.clientWidth/(16/9),
      show:false,
      contentHeight: document.body.clientHeight  -100  ,
      chengshi_list:[],
      daylist:[],
      currentDate:{
        m:"",
        y:"",
        d:""
      },
      data:{}
    }
  },
  components: {

  },
  created:function() {


    this.getData();

  },
  mounted:function(){
    this.show = true
  },
  methods: {
    elementScroll: function elementScroll(e) {
      var _this2 = this;

      this.scrolltop = e.target.scrollTop; //滚动到了底部

      if (this.scrollbottom) {
        var topheight = e.target.offsetHeight + e.target.scrollTop;

        if (topheight + 30 >= e.target.scrollHeight && this.lastscroll < e.target.scrollTop) {
          if (this.scrollTopTimeOut) {
            clearTimeout(this.scrollTopTimeOut);
            this.scrollTopTimeOut = false;
          }
          this.scrollTopTimeOut = setTimeout(function () {
            _this2.scrollbottom();
          }, 300);
        }
        this.lastscroll = e.target.scrollTop;
      }
    },
    scrollbottom: function scrollbottom() {
      this.getData();
    },
    dayClick:function(item){

      if(item.d == this.currentDate.d){
        return
      }
      this.showloading = true;
      this.currentDate = item;
      this.date_timestamp = new Date(item.y+"-" +item.m+"-"+item.d).getTime();
      var t = new Date(this.date_timestamp);
      this.currentDate = {
        y:t.getFullYear(),
        m:t.getMonth()+1,
        d:t.getDate()
      }
      this.daylist = this.datatime(14);
      this.page = 1;
      this.getData()
    },
    datatime:function (time){
      // var myDate = new Date(this.date_timestamp); //获取今天日期
      // myDate.setDate(myDate.getDate());
      // var dateArray = [];
      // var dateTemp;
      // var flag = 1;
      // for (var i = 0; i < time; i++) {
      //     let month = 0;
      //     if (myDate.getMonth() + 1 < 10) {
      //         month = '0' + (myDate.getMonth() + 1);
      //     } else {
      //         month = myDate.getMonth() + 1;
      //     }
      //     let day = 0;
      //     if (myDate.getDate() < 10) {
      //         day = '0' + myDate.getDate();
      //     } else {
      //         day = myDate.getDate();
      //     }
      //     //dateTemp = myDate.getFullYear() + '-' + month + '-' + day;
      //     dateTemp = {
      //         y:myDate.getFullYear(),
      //         m:month,
      //         d:day
      //     }
      //     dateArray.push(dateTemp);
      //     myDate.setDate(myDate.getDate() + flag);
      // }



      var myDate = new Date(this.date_timestamp);
      myDate.setDate(myDate.getDate()-time+1)
      var dateArray = [];
      var dateTemp = [];
      var flag = 1;
      for (var i = 0; i < time; i++) {
        let month = 0;
        if (myDate.getMonth() + 1 < 10) {
          month = '0' + (myDate.getMonth() + 1);
        } else {
          month = myDate.getMonth() + 1;
        }
        let day = 0;
        if (myDate.getDate() < 10) {
          day = '0' + myDate.getDate();
        } else {
          day = myDate.getDate();
        }
        // dateTemp = myDate.getFullYear() + '-' + month + '-' + day;
        dateTemp = {
          y:myDate.getFullYear(),
          m:month,
          d:day
        }
        dateArray.push(dateTemp);
        myDate.setDate(myDate.getDate() + flag);
      }

      return dateArray
    },
    onConfirm:function(value){
      this.showTimeselect = false;
      console.log(value)
      var t = new Date(value);
      if(t.getDate() == this.currentDate.d){
        return
      }
      this.showloading = true;
      this.date_timestamp = t.getTime();

      var t = new Date(this.date_timestamp);
      this.currentDate = {
        y:t.getFullYear(),
        m:t.getMonth()+1,
        d:t.getDate()
      };
      this.daylist = this.datatime(14);
      this.page = 1;
      this.getData()


    },
    getData:function(){
      var _this = this;
      var page = this.page;
      this.page = this.page+1;
      var date_timestamp = this.date_timestamp;
      request.getCengshiList({
        page:page,
        date_timestamp:date_timestamp
      }, (res,err)=> {
        // console.log(JSON.stringify(date_timestamp))
        // console.log(JSON.stringify(res))
        if(res  && res.data){
          try{
            if(res.data.constructor.name === "Object"){
              _this.data =  res.data
            }
          }catch (e) {
            console.log(e)
          }
          _this.showloading = false;
          if(res.data.chengshi_news){
            _this.chengshi_news = res.data.chengshi_news;
            if(res.data.chengshi_news.publish_time){
              var tt = res.data.chengshi_news.publish_time.replace(/-/gi, "/");
              console.log(tt)
              _this.date_timestamp = new Date(tt).getTime();
              _this.daylist = _this.datatime(14);
              var t = new Date(tt);
              _this.currentDate = {
                y:t.getFullYear(),
                m:t.getMonth()+1,
                d:t.getDate()
              }
            }

          }

          if(res && res.data && res.data.chengshi_list){
            _this.chengshi_list = res.data.chengshi_list;

          }
        }

        if(page === 1){
          request.getWeixinShanre(location.href,(s_res)=>{
            let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
            let shareconfig = {appId,timestamp,nonceStr,signature};
            if(utils.is_weixin()){
              if(res.data){
                var title = "成视新闻";



                var regex = /(<([^>]+)>)/ig;
                var result =res.data.movie_desc;



                let sharedata = {
                  title:title,
                  desc:result,
                  link:location.href,
                  imgUrl:thumb
                };
                console.log(sharedata)
                utils.setWeiXinShare(sharedata,shareconfig,false)
              }

            }
          });
        }



      })
    },
    openconstent:function(item){
      console.log(item)
      this.chengshi_news = item

    },


    setdefaultImg:function(event) {
      var el = event.currentTarget;
      el.src = '../../../image/noimg.png'
    },

  }
}
</script>
<style scoped>
  @import '../assets/css/listcomponentscss.css';

  .back img{ height: 18px; display: block}

  .lanmu_title{display: flex; justify-content: flex-start; align-items: center; padding:15px; font-size: 18px; font-weight: bold}
  .lanmu_title img{ height: 12px; margin-left: 8px}


  .TVSpots-time{ display: flex; height: 24px; line-height: 24px; color: red; align-items: center}
  .TVSpots-time svg{ width: 16px; height: 16px}
  .TVSpots-time-icon{ width: 18px; height: 18px}

  .shareBtn svg{ width: 24px; height: 24px}
  .video_placeholder img{ width: 100%; height: 100%}
  .video_placeholder{ overflow: hidden; position: relative}
  .video_placeholder_cont{ position: absolute; left: 0; top: 0; width: 100%; height: 100%; color: #fff; display: flex; flex-direction: column; justify-content: center; align-items: center; font-size: 16px; background-color: rgba(0,0,0,0.3)}
  .video_placeholder_date{ display: flex; align-items: center; margin-top: 10px}
  .time-big-text{ display: flex; justify-content: center; align-items: center; width: 46px;height: 50px; border:0.5px solid rgba(255,255,255,0.5); border-radius: 4px; margin: 0 8px;font-family: Oswald-Medium;
    font-size: 30px; font-weight: bold}
  .tv-player-placeholder{ position: relative; width: 100%; overflow: hidden}
  .tv-player-placeholder-poster{ width: 100%; height: 100%}
  .tv-player-placeholder-icon{ position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%)}
  .tv-player-placeholder-icon img{ width: 80px; height: 80px;}
  .playerTemp,.playerTemp video{ border-radius: 0}
  .playerTemp{ padding-top: 30px}


  .left-img-list-item.active .news-list-item-title{ color: red}
  .news-list-item-date{ justify-content: space-between}
  .news-list-item-title{ margin-bottom: 0}
  .share,.news-list-item-date-more{ display: flex; align-items: center; color: #999999; padding: 0 8px}
  .news-list-item-date-more{ }
  .share svg{ width: 18px; height: 18px; }
  .news-list-item-date-r{ display: flex; align-items: center}
  .news-list-item-date-more svg{ width: 20px; height: 20px; padding-top: 2px}
  /*.scroll-x-item.active:after{ position: absolute; width: 20px; height: 1px; background-color:#ffd17c; content: " "; left: 50%; bottom:0; transform: translateX(-50%) }*/
  .item-desc{ font-size: 12px; line-height: 18px; height: 18px;
    color: #D2D6D9;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .view{ padding:0 15px; position: relative; margin: 20px 0; margin-bottom:30px}
  .view_sd1{ width: 100%; background-color: #fff; border-radius: 10px; box-shadow: 0 0 5px #c9cacb; position: relative; z-index: 10; padding: 10px; display: flex; justify-content: space-between; align-items: center}
  .view_sd2{width:85%; height: 30px; background-color: #fff; border-radius: 10px; box-shadow: 0 0 5px #c9cacb; position: absolute; z-index: 9; left: 50%; transform: translateX(-50%); bottom:-5px}
  .view_sd3{width:80%; height: 30px; background-color: #fff; border-radius: 10px; box-shadow: 0 0 5px #c9cacb; position: absolute; z-index: 8; left: 50%; transform: translateX(-50%); bottom:-10px}
  .view_more{ position: absolute; right: 30px; font-size: 10px; color: #7a7b7c;z-index: 11; bottom: 2px;
  }
  .left-date{ padding: 10px 0; padding-right: 10px; margin-right: 10px; border-right:0.5px solid #c9cacb; font-size: 16px; font-weight: bold; text-align: center; line-height: 1.3; }
  .right-date{display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; flex: 1; max-width: 85%}
  .right-date-item{width: 14%; height: 30px; display: flex; justify-content: center; align-items: center;}
  .right-date-item-t{ width: 20px; height: 20px; text-align: center; line-height: 20px; border-radius: 50%; font-size: 14px; }
  .right-date-item-t.active{background-color:#fe4532; color: #fff }

  .chengshi_video{ display: block; width: 100%}
  .cs{ position: absolute; width: 100%; height: 100vh; left: 0; top:0}
  .scrollView{ height: 100vh}
  .content__loading{ height: 100vh}
</style>
